import { bl_pos_terminal_device_drawer_link_history_RowClass } from '../../../dbschema/bl_pos_terminal_device_drawer_link_history.model';
import {BaseContainerModel} from '../../base-container.model';


export class PosTerminalDeviceDrawerLinkHistoryContainerModel extends BaseContainerModel {
  bl_pos_terminal_device_drawer_link_history: bl_pos_terminal_device_drawer_link_history_RowClass = new bl_pos_terminal_device_drawer_link_history_RowClass();
}
